<div class="section-disparo">
  <!-- <div>
    <span class="cabecalho-painel">Dados do Disparo</span>
    <div class="divisor-roxo"></div>
  </div> -->
  <div class="painel-dados">

    <div class="corpo-painel">
      <div class="campo">
        <div class="flex justify-between align-center">
          <span class="label-campo">Título Disparo</span>
          @if (disparoAutomatico.status) {
            <span [class]="'card-status ellipse ' + classeStatusDisparo(disparoAutomatico.status)">{{ disparoAutomatico.status }}</span>
          }
        </div>
        @if (podeEditar) {
          <app-form-field
            label=""
            placeholder="Digite um título"
            heightFormField="40px"
            [value]="disparoAutomatico.tituloDisparo"
            (changeValue)="alterarTitulo($event)">
          </app-form-field>
        } @else {
          <span class="valor-campo">{{ disparoAutomatico.tituloDisparo ?? '--' }}</span>
        }
      </div>
      @if (exibirProgramacao) {
        <app-programacao-disparo-form
          [tipoProgramacao]="tipoProgramacao"
          [programacao]="programacao"
          [dataAgendamento]="disparoAutomatico.dataAgendamento"
          [horaAgendamento]="disparoAutomatico.horaAgendamento"
          [disabled]="!podeEditar"
          (tipoProgramacaoChange)="atualizarTipoProgramacao($event)"
          (programacaoChange)="atualizarProgramacao($event)"
          (agendamentoChange)="receberAgendamento($event)">
        </app-programacao-disparo-form>
      }

      @if (disparoAutomatico.dataEnvio) {
        <div class="campo">
          <span class="label-campo">Data Envio</span>
          <span class="valor-campo">{{ (disparoAutomatico.dataEnvio | date:'dd/MM/yyyy - HH:mm') ?? '--' }}</span>
        </div>
      }

      @if (disparoAutomatico.id) {
        <div class="campo">
          <span class="label-campo">Informações</span>
          @if (disparoAutomatico.template?.conta) {
            <span class="valor-campo">{{ (disparoAutomatico.template?.conta?.numero + ' - ' + disparoAutomatico.template?.conta?.nome) || '--' }}</span>
          }
          <span class="valor-campo">Setor: {{ disparoAutomatico.setor?.nome || '--' }}</span>
        </div>
      }

      <!-- @if (interacoesUsuarios && interacoesUsuarios.length > 0) {
        <div class="campo">
          <span class="label-campo">Interações Usuários</span>
          <div class="interacoes-usuario">
            @for (interacao of interacoesUsuarios; track interacao.id) {
              <div class="flex justify-between align-center">
                <div class="flex-direction-column gap-4">
                  <span class="font-12 weight-600">{{ (interacao.tipo | titlecase) + ' por' }}</span>
                  <span class="font-11 weight-400">{{ interacao.data | date:'dd/MM/yyyy - HH:mm' }}</span>
                </div>
                @if (interacao.usuario.extensaoImg && interacao.usuario.uuid) {
                  <img [matTooltip]="interacao.usuario.nome" class="avatar-interacao" [src]="gerarUrl(interacao.usuario.uuid, interacao.usuario.extensaoImg, 'usuario-img')" />
                } @else {
                  <img [matTooltip]="interacao.usuario.nome" class="avatar-interacao" src="./assets/icones/no-img-default.png" />
                }
              </div>
            }
          </div>
        </div>
      } -->
    </div>
    <div class="rodape-painel">
      @if (podeSalvar) {
        <app-button-padrao
          width="100%"
          [label]="salvando ? 'Salvando...' : 'Salvar'"
          backgroundColor="white"
          color="var(--verde-padrao)"
          borderColor="var(--verde-padrao)"
          borderStyle="solid"
          borderWidth="1px"
          [disabled]="salvando"
          (buttonClick)="salvarDisparoAutomatico()"></app-button-padrao>
      }
      @if (podeEditar && tipoProgramacao === 'Padrão') {
        <app-button-padrao
          width="100%"
          label="Enviar"
          backgroundColor="var(--verde-padrao)"
          color="white"
          [disabled]="enviarDesabilitado"
          (buttonClick)="enviarDisparoAutomatico()"></app-button-padrao>
      }
      @if (podePausar) {
        <app-button-padrao
          width="100%"
          [label]="alterandoPausa ? 'Pausando...' : 'Pausar Envio'"
          [backgroundColor]="corBotaoPausar"
          color="white"
          [disabled]="alterandoPausa"
          (buttonClick)="pausarDisparo()"></app-button-padrao>
      }
      @if (estaPausado) {
        <app-button-padrao
          width="100%"
          [label]="alterandoPausa ? 'Verificando template...' : 'Despausar Envio'"
          backgroundColor="var(--verde-padrao)"
          color="white"
          [disabled]="alterandoPausa"
          (buttonClick)="despausarDisparo()"></app-button-padrao>
      }
      @if (disparoAutomatico.status && disparoAutomatico.status !== 'Enviado' && disparoAutomatico.status !== 'Cancelado' && disparoAutomatico.status !== 'Erro') {
        <app-button-padrao
          width="100%"
          label="Cancelar / Interromper Envio"
          backgroundColor="var(--vermelho-padrao)"
          color="white"
          (buttonClick)="cancelarEnvios(disparoAutomatico)"></app-button-padrao>
      }
      <app-button-padrao
        width="100%"
        label="Cancelar"
        backgroundColor="white"
        color="var(--vermelho-padrao)"
        borderColor="var(--vermelho-padrao)"
        borderStyle="solid"
        borderWidth="1px"
        [disabled]="salvando"
        (buttonClick)="cancelarEdicao()"></app-button-padrao>
    </div>
  </div>
</div>
